import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card, CardActionArea, Chip, Paper, Stack, Typography, } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { memo, Suspense } from "react";
import { getTextByStatus } from "../helpers";
import { useViewer } from "../../../providers/ViewerProvider";
import { Skeleton } from "../../../components/Skeleton";
import { FullScreen360Async, useFullScreenMode } from "../../FullScreen360";
import { Suspense360Loading } from "../../../components/Fallback";
var MIN_WIDTH = 150;
var MAX_WIDTH = 370;
var CARD_RATIO = "37 / 22";
export var IntroTeaser = memo(function () {
    var _a = useFullScreenMode(), isFullScreen = _a.isFullScreen, changeFullScreen = _a.changeFullScreen;
    var _b = useViewer(), status = _b.status, previewUrl = _b.previewUrl, defaultMedia = _b.defaultMedia, isLoadingPreview = _b.isLoadingPreview;
    var text = getTextByStatus(status);
    var defaultUrl = defaultMedia === null || defaultMedia === void 0 ? void 0 : defaultMedia.teaser360.urls.preview;
    var handleOpenFullScreen = function () {
        changeFullScreen(true).then(function () { });
    };
    var handleCloseFullScreen = function () {
        changeFullScreen(false).then(function () { });
    };
    var handleImageError = function (event) {
        var target = event.target;
        if (!defaultUrl || target.src === defaultUrl) {
            return;
        }
        target.src = defaultUrl;
    };
    return (_jsxs(_Fragment, { children: [_jsx(Card, __assign({ sx: {
                    p: 0.5,
                    width: "100%",
                    height: "100%",
                    minWidth: MIN_WIDTH,
                    maxWidth: MAX_WIDTH,
                    aspectRatio: CARD_RATIO,
                } }, { children: _jsx(CardActionArea, __assign({ onClick: handleOpenFullScreen, disabled: status == null, sx: { position: "relative", height: "inherit" } }, { children: _jsxs(Stack, __assign({ flexDirection: "column", position: "relative", height: "100%" }, { children: [_jsx(Paper, __assign({ elevation: 0, sx: { width: "100%", height: "100%", overflow: "hidden" } }, { children: _jsx(Skeleton, __assign({ showIf: !isLoadingPreview, variant: "rectangular", sx: { height: "100%", bgcolor: "background.default" } }, { children: _jsx(LazyLoadImage, { src: previewUrl || defaultUrl, width: "100%", height: "100%", effect: "blur", onError: handleImageError }) })) })), _jsx(Stack, __assign({ sx: {
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    p: 0.8,
                                } }, { children: _jsx(Chip, { color: "primary", label: _jsx(Typography, __assign({ variant: "button" }, { children: _jsx(Skeleton, __assign({ showIf: status, width: 60 }, { children: text })) })) }) }))] })) })) })), isFullScreen && (_jsx(Suspense, __assign({ fallback: _jsx(Suspense360Loading, { onClose: handleCloseFullScreen }) }, { children: _jsx(FullScreen360Async, { onClose: handleCloseFullScreen }) })))] }));
});
